import React, {useState, useEffect, useRef} from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/logo.png';
import { MdSearch } from "react-icons/md";
import { BiSave } from "react-icons/bi";
import Select from 'react-select';
import Swal from 'sweetalert2';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';


export default function Acompanhamento(){

    const [unidades, setUnidades] = useState([]);
    const [representantes, setRepresentantes] = useState([]);
    const [aviso, setAviso] = useState("d-none");
    const selectRef = useRef(null);
    const [loadingPesquisar, setLoadPesquisar] = useState(false);
    const [loadingGravar, setLoadGravar] = useState(false);
    const [loading, setLoad] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [editar, setEditar] = useState(false);

    useEffect(()=>{
        consultarUnidades();
    }, []);

    const consultarUnidades = () =>
    {
        setLoad(true);
        axios.get(process.env.REACT_APP_API + 'Unidades/Minimal/', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            setLoad(false);
            if(response.data.statusCode === 400) {
                Swal.fire({
                    title: 'Não foi possível buscar os dados',
                    text: response.data.value.message,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
                return;
            }
            else {
                setUnidades([]);   
                response.data.value.forEach((item) => {
                    setUnidades(unidades => [...unidades,{label:item.nomeSimplificado, value:item.unidadeId}]);
                })
            }
        }).catch((error) => {
            sessionStorage.clear();
             window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarRepresentantes = (unidadeId) =>
    {
        if(!selectedOption) return;
        setLoadPesquisar(true);
        axios.get(process.env.REACT_APP_API + 'Representantes/Unidades/'+unidadeId, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {    
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }        
            if(response.data.statusCode === 400) {
                setAviso(""); 
                setRepresentantes([]);
            }
            else {
                setAviso("d-none");
                setRepresentantes(response.data.value);
            }
            setLoadPesquisar(false);
        }).catch((error) => {
            sessionStorage.clear();
             window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const selecionarRepresentante = (index, checked) => 
    {
        checked = checked ? false : true;
        var updatedList = [...representantes];
        updatedList[index].selecionado = checked;
        setRepresentantes(updatedList);
        setEditar(true);
    }

    const gravarRepresentante = () =>
    {
        setLoadGravar(true);
        var pessoaFuncionario = [];
        var unidadeDesignacao = [];
        representantes.forEach((item) => {
            if(item.pessoaFuncionarioId !== null && item.selecionado) pessoaFuncionario.push(item.pessoaFuncionarioId);
            else if(item.pessoaFuncionarioId === null && item.selecionado) unidadeDesignacao.push(item.unidadeDesigncaoId);
        })
        
        var dados = {
            unidadeId:selectedOption.value,
            pessoaFuncionario:pessoaFuncionario,
            unidadeDesignacao:unidadeDesignacao
        };
        //salvar no banco de dados
        axios.put(process.env.REACT_APP_API + 'Representantes/',dados, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
           setLoadGravar(false);
           setEditar(false);
        }).catch((error) => {
            sessionStorage.clear();
             window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        consultarRepresentantes(selectedOption.value);
    }

    const selecionarUnidade = (event) => {
        if(editar)
        {
            Swal.fire({
                title: "Tem certeza?",
                text: "Há representantes que não foram salvos. Deseja gravar?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#2F4F4F",
                confirmButtonText: "Sim, gravar!",
                cancelButtonText:"Não",
                }).then((result) => {
                if (result.isConfirmed) {
                    gravarRepresentante();
                    setSelectedOption(event)
                    consultarRepresentantes(event.value);
                    setEditar(false);
                }
                else {
                    setSelectedOption(event)
                    consultarRepresentantes(event.value);
                    setEditar(false);
                }
            });
        }
        else 
        {
            setSelectedOption(event)
            consultarRepresentantes(event.value);
        }
    }
    

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background rounded p-3">
                            <div className="text-center mb-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}}/>
                            </div>
                            <p className="text-center fw-bold fs-5 mb-0">REPRESENTANTES WEBSAI</p>
                            <p className="text-center">Selecione aqui os representantes de sua unidade. A seleção se restringe aos docentes, funcionários ou coordenadores.</p>
                            <hr/>
                            <div className="bg-white rounded p-3 border mb-2">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="idunidade">Selecione a unidade</label>
                                            <Select
                                                options={unidades}
                                                onChange={selecionarUnidade}
                                                placeholder={loading ? "Carregando..." : "Selecione..."}
                                                ref={selectRef}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2 col-sm-4 mx-auto">
                                        <button type="submit" className="btn btn-custom mt-2">
                                            <MdSearch/> {loadingPesquisar ? "Carregando... " : "Pesquisar "}
                                            <RotatingLines
                                                strokeColor="white"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                width="20"
                                                visible={loadingPesquisar}
                                            />
                                            </button>
                                    </div>
                                </form>  
                            </div>

                            <div className={"col-sm-12 "+aviso}>
                                <div className="alert alert-warning">Não foram localizados registros</div>
                            </div>

                            {
                            typeof representantes !== "undefined" && representantes.length > 0 ?
                            <div className="bg-white rounded p-3 border mb-2">
                                <div className="col-sm-12">
                                    <button className="btn btn-custom btn-sm mb-3 float-end" onClick={gravarRepresentante}><BiSave/> {loadingGravar ? "Aguarde... " : "Gravar "}
                                            <RotatingLines
                                                strokeColor="white"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                width="20"
                                                visible={loadingGravar}
                                            /></button>
                                    <table className="table table-striped table-bordered" id="table-representantes">
                                        <thead className="table-head-scroll">
                                            <th>Nome</th>
                                            <th>Emprego</th>
                                            <th>Representante</th>
                                        </thead>
                                        <tbody className="table-body-scroll">
                                            {
                                                representantes.map((item, index) => 
                                                <tr className="table-head-scroll">
                                                    <td>{item.nomeCompleto}</td>
                                                    <td>{item.emprego}</td>
                                                    <td>
                                                        <div className="form-check form-switch">
                                                            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={item.selecionado} onChange={() => {selecionarRepresentante(index, item.selecionado)}}/>
                                                        </div>
                                                    </td>
                                                </tr>
                                                
                                            )} 
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                             :null}
                            

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" className="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" className="title"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}